import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function QuoteStepRedirect() {
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => navigate('/quote', { replace: true }), 400);
    const failTimer = setTimeout(() => setFailed(true), 5000);
    return () => { clearTimeout(timer); clearTimeout(failTimer); };
  }, [navigate]);

  if (failed) {
    return (
      <div className="min-h-[60vh] flex flex-col items-center justify-center px-4 text-center">
        <p className="text-gray-700 mb-4">Something went wrong.</p>
        <a href="/quote" className="text-[#1e3a5f] font-semibold underline">
          Click here to start your quote
        </a>
      </div>
    );
  }

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="w-8 h-8 border-2 border-[#1e3a5f] border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
